<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <form name="contactRuleForm" [formGroup]="contactRuleForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <mat-label>{{ "Período de Mensaje" | translate }}</mat-label>
        <mat-form-field appearance="outline">
            <mat-select placeholder="" formControlName="periodCatalogId" required>
                <mat-option>-- {{ "Seleccionar" | translate }} --</mat-option>
                <mat-option *ngFor="let messagePeriod of periods" [value]="messagePeriod.id">
                    {{ messagePeriod.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-label>{{ "Cantidad de Mensajes" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="message_quantity" formControlName="message_quantity" type="number" mat-maxlength="50"
                placeholder="" autocomplete="off" required />
        </mat-form-field>

        <mat-label>{{ "Dias de contactabilidad" | translate }}</mat-label>
        <app-tag-input [roles]="dates" [userRoles]="itemsEdit" [actionInput]="actionInput"
            (tagAddItem)="addItem($event)" (tagDeleteItem)="deleteItem($event)">
        </app-tag-input>

        <br clear="all" />
        <div class="row">
            <div class="col-6">
                <mat-label>{{ "Hora de inicio" | translate }}</mat-label>
                <ngx-mat-timepicker-field controlOnly="true" name="hour_period_init" formControlName="hour_period_init"
                    [format]="24" placeholder="16:00"></ngx-mat-timepicker-field>
            </div>
            <div class="col-6">
                <mat-label>{{ "Hora de fin" | translate }}</mat-label>
                <ngx-mat-timepicker-field controlOnly="true" name="hour_period_end" formControlName="hour_period_end"
                    [format]="24" placeholder="16:00"></ngx-mat-timepicker-field>
            </div>
        </div>





        <br clear="all" />
        <br clear="all" />

        <div fxLayout="row" fxLayoutAlign="end end">
            <button mat-raised-button (click)="saveRule()" class="submit-button" [disabled]="contactRuleForm.invalid"
                aria-label="Guardar">
                <span class="material-icons-outlined"> save </span>
                <span> {{ "Guardar" | translate }}</span>
            </button>
        </div>
    </form>
</wtf-dialogcontent>